module.exports = __webpack_public_path__ + "static/ebook_cover03-2223375a9e65a6dbbe9cf4c3b4ffa093.jpg";